import { Component } from '@angular/core';
import { StorageService } from '../../services/storage/storage.service';
import { SESSION_DEPARTMENT_LIST, SESSION_OPERATION_MODE } from '../../app.constants';
import { CartService } from '../../services/cart/cart.service';
import { Cart } from '../../models/cart.model';
import { ItemListService } from '../../services/shared/item-list.service';
import { OOModule } from '../../modules/oo.module';
import { MatModule } from '../../modules/mat.module';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { NotificationService } from '../../services/shared/notifications.service';

@Component({
  selector: 'app-operation-mode-header',
  imports: [OOModule, MatModule, MatTabsModule, CommonModule, RouterModule],
  templateUrl: './operation-mode-header.component.html',
  styleUrl: './operation-mode-header.component.scss'
})
export class OperationModeHeaderComponent {
  instoreMode: any;
  preparationTime: any;
  cart: Cart;
  saleItemList: any;
  deliveryMethod: any;
  deliveryDate: any;
  deliveryDateTime: string;
  selectedShop: any;
  deliveryTime: any;
  qrInfo: any;

  constructor(private storageService: StorageService,
    private cartService: CartService,
    private itemListService: ItemListService,
    private router: Router,
    private notificationService: NotificationService,
  ) {
    this.cart = this.cartService.cart;
    this.saleItemList = this.itemListService.saleItemList;
    const businessType = this.cart.businessType;
    this.preparationTime = businessType.initialDelay;
    // console.log(this.saleItemList)
    // this.customizationDetail = [];
    const departmentList = JSON.parse(this.storageService.loadFromSession(SESSION_DEPARTMENT_LIST));
    const commonDept = departmentList.find((dept: any) => dept.code === 'COMMON');

    this.selectedShop = this.cartService.getShop();
    this.deliveryDate = this.cartService.getDeliveryDate();
    this.deliveryTime = this.cartService.getDeliveryTime();

    this.deliveryMethod = this.cartService.getService();
    this.deliveryDateTime = this.deliveryDate.date + " " + this.deliveryTime;

    this.refreshModeInfo();
  }

  refreshModeInfo() {
    const mode = JSON.parse(this.storageService.loadFromSession(SESSION_OPERATION_MODE));
    if (mode !== null && mode !== undefined && mode.length !== 0) {
      this.qrInfo = mode;
      this.instoreMode = true;
    } else {
      this.instoreMode = false;
    }
    this.deliveryMethod = this.cartService.getService();
  }

  ngOnInit() {
    this.notificationService.cartChanged.subscribe(() => {
      this.refreshModeInfo();
    });
  }

  navigateToshopList() {
    this.router.navigate(['/shopList']);
  }
}
